import { ElMessage } from 'element-plus';
import UserApi from '@/frontend/api/user';
export default {
  name: "LoginPage",

  data() {
    return {
      form: {
        username: '',
        password: '',
        rememberMe: 0
      },
      hiddenPassword: true
    };
  },

  computed: {
    passwordType() {
      return this.hiddenPassword ? 'password' : 'text';
    }

  },
  methods: {
    handlerSubmit() {
      UserApi.signIn(this.form).then(() => window.location.href = window.history.state.back).catch(error => {
        if (!error) {
          console.error(error);
          ElMessage.error(error.message || 'Непредвиденная ошибка!');
          return;
        }

        if (error && error.type === 'authorized') this.$router.go(-1);

        if (error.type === 'validate' || error.type === 'not found') {
          ElMessage({
            message: Array.isArray(error.message) ? error.message[0] : error.message,
            type: 'warning'
          });
          console.log(error);
          return;
        }

        ElMessage.error('Отсутствует обработчик ошибки!');
        console.error(error);
      });
    }

  }
};